import { isAxiosError } from 'axios';
import { t } from 'i18next';

/** player-backend errorCode for "this account already has a verified phone" — callers treat it as success. */
export const PHONE_OTP_ALREADY_VERIFIED = 3019;

const GENERIC_KEY = 'common.error.somethingWentWrong';

const MESSAGE_KEYS: Record<number, string> = {
  3104: 'phoneVerification.invalidVerificationCode',
  3106: 'auth.firebaseErrors.tooManyRequests',
  3137: 'auth.firebaseErrors.invalidPhoneNumber',
  3138: 'phoneVerification.codeExpired',
  3139: 'phoneVerification.phoneNumberAlreadyInUseError',
  3140: 'phoneVerification.regionNotSupported',
};

/** A `v2/user/phone-otp/*` failure, carrying the translated message so `getErrorMessage` shows it as is. */
export class PhoneOtpError extends Error {
  constructor(
    public readonly messageKey: string,
    public readonly errorCode?: number,
  ) {
    super(t(messageKey as never));
    this.name = 'PhoneOtpError';
  }
}

export function toPhoneOtpError(error: unknown): PhoneOtpError {
  const errorCode = isAxiosError(error)
    ? (error.response?.data as { errors?: { errorCode?: number }[] } | undefined)?.errors?.[0]?.errorCode
    : undefined;

  return new PhoneOtpError((errorCode !== undefined && MESSAGE_KEYS[errorCode]) || GENERIC_KEY, errorCode);
}
